<template>
  <div class="view welcome" @click="start">
    <div class="welcome__logo orbitron">VEEV</div>

    <div class="welcome__center">
      <p class="welcome__eyebrow orbitron">DISCOVER</p>
      <h1 class="welcome__title orbitron neon-text">
        YOUR<br>ALTER EGO
      </h1>
      <p class="welcome__sub">
        Fă-ți selfie, răspunde la câteva întrebări<br>
        și descoperă cine ești cu adevărat după dark.
      </p>
    </div>

    <div class="welcome__tap">
      <div class="tap-ring tap-ring--3"></div>
      <div class="tap-ring tap-ring--2"></div>
      <div class="tap-ring tap-ring--1"></div>
      <div class="tap-btn orbitron">
        <span>TAP TO START</span>
      </div>
    </div>

    <div class="welcome__bottom orbitron">
      FOR ADULTS ONLY — 18+
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useSessionStore } from '@/store/session'

const router = useRouter()
const session = useSessionStore()

function start() {
  session.reset()
  session.startSession()
  router.push('/selfie')
}
</script>

<style scoped>
.welcome {
  gap: 0;
  justify-content: space-between;
  padding: 3rem 4rem;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.welcome__logo {
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 0.4em;
  color: rgba(255, 255, 255, 0.3);
}

.welcome__center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.welcome__eyebrow {
  font-size: 1rem;
  letter-spacing: 0.5em;
  color: rgba(139, 92, 246, 0.8);
  margin-bottom: 1.5rem;
}

.welcome__title {
  font-size: clamp(4rem, 10vw, 8rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0.05em;
  color: #fff;
  text-shadow: 0 0 60px rgba(139, 92, 246, 0.8), 0 0 120px rgba(59, 130, 246, 0.4);
  margin-bottom: 2rem;
}

.welcome__sub {
  font-size: 1.3rem;
  font-weight: 300;
  letter-spacing: 0.05em;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.7;
}

.welcome__tap {
  position: relative;
  width: 180px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem auto;
}

.tap-btn {
  position: relative;
  z-index: 3;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: rgba(139, 92, 246, 0.15);
  border: 2px solid rgba(139, 92, 246, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: #fff;
  box-shadow: 0 0 30px rgba(139, 92, 246, 0.5), inset 0 0 30px rgba(139, 92, 246, 0.1);
  animation: tapPulse 2s ease-in-out infinite;
}

.tap-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(139, 92, 246, 0.4);
  animation: ringExpand 3s ease-out infinite;
}

.tap-ring--1 { width: 160px; height: 160px; animation-delay: 0s; }
.tap-ring--2 { width: 180px; height: 180px; animation-delay: 0.8s; }
.tap-ring--3 { width: 200px; height: 200px; animation-delay: 1.6s; }

@keyframes tapPulse {
  0%, 100% { box-shadow: 0 0 30px rgba(139, 92, 246, 0.5), inset 0 0 30px rgba(139, 92, 246, 0.1); }
  50% { box-shadow: 0 0 60px rgba(139, 92, 246, 0.8), inset 0 0 40px rgba(139, 92, 246, 0.2); }
}

@keyframes ringExpand {
  0% { transform: scale(0.8); opacity: 0.8; }
  100% { transform: scale(1.5); opacity: 0; }
}

.welcome__bottom {
  font-size: 0.7rem;
  letter-spacing: 0.3em;
  color: rgba(255, 255, 255, 0.2);
}
</style>
